<div class="ds-list-page" [class.ds-list-page--embedded]="!!unitId">
  <span *ngIf="unitId" class="development-ribbon">En desarrollo</span>
  <div *ngIf="!unitId" class="ds-header">
    <mat-icon class="ds-header-icon">event</mat-icon>
    <div class="ds-header-text">
      <h2 class="ds-title">{{ unitName ? 'Servicios Divinos en ' + unitName : 'Servicios Divinos' }}</h2>
      <p class="ds-subtitle">Gestiona todos los servicios divinos</p>
    </div>
  </div>

  <mat-card class="ds-card table-surface-card">
    <mat-card-content>
      <app-table-surface
          title="Servicios divinos"
          titleIcon="event"
          [columns]="columns"
          [data]="tableData"
          [isLoading]="isLoading"
          [paginationConfig]="paginationConfig"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[5, 10, 25, 50]"
          [cellTemplate]="cellContent"
          [activeFilters]="activeFilterChips"
          tableId="divine-services-list"
          [enableSearch]="true"
          searchPlaceholder="Buscar texto biblico..."
          [enableFilter]="true"
          [enableSort]="true"
          [sortState]="currentSort"
          [enableColumnVisibility]="true"
          [enableDensity]="true"
          [primaryActionLabel]="canManageDivineServices ? 'Nuevo' : undefined"
          [readonly]="!canManageDivineServices"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (rowClick)="viewDivineService($event)"
          (sortChange)="onSortChange($event)"
          (searchChange)="onToolbarSearch($event)"
          (filterRemove)="onFilterRemove($event)"
          (toolbarSortChange)="onToolbarSort($event)"
          (primaryActionClick)="createDivineService()">
          <div filterPanel class="filters-form">
            <div class="filter-row filter-row--search">
              <app-unit-selector
                *ngIf="showUnitFilter"
                [label]="'Unidad'"
                floatLabel="always"
                [required]="false"
                [unitSource]="unitFilterSource"
                [groupByLevel]="true"
                groupByMode="level"
                (unitSelected)="selectedUnitIdControl.setValue($event)">
              </app-unit-selector>

              <app-date-range-picker
                class="date-range-field"
                label="Periodo"
                startPlaceholder="DD/MM/AAAA"
                endPlaceholder="DD/MM/AAAA"
                [formGroup]="dateRangeGroup">
              </app-date-range-picker>

              <div class="filter-field">
                <span class="filter-field__label">Tipo SD</span>
                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                  <mat-select aria-label="Tipo SD" [formControl]="selectedTypeIdControl">
                    <mat-option [value]="null">Todos</mat-option>
                    <mat-option *ngFor="let type of serviceTypes" [value]="type.value">
                      {{ type.name || type.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>
          </div>
      </app-table-surface>

      <ng-template #cellContent let-column="column" let-row="row">
          <div *ngIf="column === 'serviceInfo'" class="service-info-column">
            <div class="service-date">
              <mat-icon class="info-icon">calendar_today</mat-icon>
              <strong>{{ formatDate(row.startAt) }}</strong>
            </div>
            <div class="service-type">
              <mat-icon class="info-icon">category</mat-icon>
              {{ row.divineServiceTypeName || row.typeName }}
            </div>
          </div>

          <div *ngIf="column === 'community'" class="community-column">
            <mat-icon class="info-icon">church</mat-icon>
            <span>{{ row.organizationUnitName || 'Sin asignar' }}</span>
          </div>

          <div *ngIf="column === 'bibleText'" class="bible-text-column">
            <span [title]="row.bibleText" class="bible-text">{{ row.bibleText || '-' }}</span>
          </div>

          <div *ngIf="column === 'status'">
            <span class="service-status" [class.service-status--closed]="isClosed(row)">
              <mat-icon>{{ isClosed(row) ? 'lock' : 'lock_open' }}</mat-icon>
              {{ isClosed(row) ? 'Cerrado' : 'Abierto' }}
            </span>
          </div>

          <div *ngIf="column === 'attendance'" class="attendance-detail-column">
            <div class="attendance-item">
              <span class="attendance-label">May</span>
              <span class="attendance-value">{{ row.totalAdults }}</span>
            </div>
            <div class="attendance-item">
              <span class="attendance-label">Men</span>
              <span class="attendance-value">{{ row.totalMinors }}</span>
            </div>
            <div class="attendance-item attendance-total">
              <span class="attendance-label">Total</span>
              <span class="attendance-value">{{ (row.totalAdults || 0) + (row.totalMinors || 0) }}</span>
            </div>
          </div>

      </ng-template>
    </mat-card-content>
  </mat-card>
</div>
